// Types
const action_header = "contactPage/";

export default {
  ADD_CONTACT_DETAILS: action_header + "ADD_CONTACT_DETAILS",
  ADD_CONTACT_DETAILS_SUCCESS: action_header + "ADD_CONTACT_DETAILS_SUCCESS",
  ADD_CONTACT_DETAILS_FAILED: action_header + "ADD_CONTACT_DETAILS_FAILED",
};
